import { render } from "./ApproveUsers.vue?vue&type=template&id=21c7386c&scoped=true"
import script from "./ApproveUsers.vue?vue&type=script&lang=js"
export * from "./ApproveUsers.vue?vue&type=script&lang=js"

import "./ApproveUsers.vue?vue&type=style&index=0&id=21c7386c&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c7386c"]])

export default __exports__